import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@deseretbook/react-ui'
import { withCheckout } from '../CheckoutContext'
import PaymentSourceDetails from './PaymentSourceDetails'
import PaymentStepAddons from './PaymentStepAddons'

/**
 * Summary of the payment step. To be used only as part of the checkout flow.
 * @returns {function} Component
 */
const PaymentStepSummary = ({ order, availablePaymentMethods }) => {
  const { payments } = order

  return (
    <React.Fragment>
      <Box maxWidth={20}>
        {payments
          .filter(({ state }) => state === 'checkout')
          .map(({ source, amount }) => (
            <PaymentSourceDetails
              source={source}
              amount={amount}
              key={source.id}
            />
          ))}
      </Box>
      {!!(['payment', 'confirm'].includes(order.state)) && (
        <PaymentStepAddons availablePaymentMethods={availablePaymentMethods} />
      )}
    </React.Fragment>
  )
}

PaymentStepSummary.propTypes = {
  order: PropTypes.shape({
    payments: PropTypes.array,
    total: PropTypes.string,
    state: PropTypes.string,
  }).isRequired,
  availablePaymentMethods: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
  })),
}

PaymentStepSummary.defaultProps = {
  availablePaymentMethods: [],
}

export default withCheckout(PaymentStepSummary)
